import LoadingScreen from 'components/LoadingScreen';
import LayoutV1 from 'layouts/layout-v1/DashboardLayout';
import LayoutV2 from 'layouts/layout-v1/NaverLayout';
import { lazy, Suspense } from 'react';
import { Navigate } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import ReportCreatorFull from './page-sections/report-creator/creator-full';
import Membership2 from './pages/Membership2';
import CallmetellmeCategoryList from './pages/callmetellme/comminity/category-list';
import CallmetellmeCommunityDetail from './pages/callmetellme/comminity/community-detail';
import PostDetail from './pages/callmetellme/jiwongum/post-detail';
import AIRecommendedPolicyFunds from './pages/callmetellme/mypage/AIRecommendedPolicyFunds';
import AIRecommendedSupportPrograms from './pages/callmetellme/mypage/AIRecommendedSupportPrograms';
import BookmarkedPosts from './pages/callmetellme/mypage/BookmarkedPosts';
import BookmarkedSupportPrograms from './pages/callmetellme/mypage/BookmarkedSupportPrograms';
import CommentsOnMyPosts from './pages/callmetellme/mypage/CommentsOnMyPosts';
import MyComments from './pages/callmetellme/mypage/MyComments';
import MyPosts from './pages/callmetellme/mypage/MyPosts';
import RepliesToMyComments from './pages/callmetellme/mypage/RepliesToMyComments';
import SubscribedProducts from './pages/callmetellme/mypage/SubscribedProducts';

// CRM pages
import BannerSettings from './pages/crm/banner-settings';
import CommentList from './pages/crm/comment-list';
import CreateBoard from './pages/crm/create-board';
import CustomerList from './pages/crm/customer-list';
import ReportedPostsAndComments from './pages/crm/reported-posts-and-comments';
import UserInfo from './pages/crm/user-info';
import YoutubeUpload from './pages/crm/youtube-upload';

const Loadable = Component => props => {
  return (
    <Suspense fallback={<LoadingScreen />}>
      <Component {...props} />
    </Suspense>
  );
}; // dashboards

const CRM = Loadable(lazy(() => import('./pages/dashboards/crm')));
const Sales = Loadable(lazy(() => import('./pages/dashboards/sales')));
const SalesV2 = Loadable(lazy(() => import('./pages/dashboards/sales-v2')));
const SaaS = Loadable(lazy(() => import('./pages/dashboards/saas')));
const Excel = Loadable(lazy(() => import('./pages/excel/excel')));
const Excel2 = Loadable(lazy(() => import('./pages/excel/excel2')));
const Progress = Loadable(lazy(() => import('./pages/dashboards/progress')));
const Progress2 = Loadable(lazy(() => import('./pages/dashboards/progress2')));
const Naver = Loadable(lazy(() => import('./pages/naver')));
const NaverList = Loadable(lazy(() => import('./pages/naverList')));
const NoticeDetail = Loadable(lazy(() => import('./pages/noticeDetail')));
const Calendar = Loadable(lazy(() => import('./pages/calendar')));
const ForumList = Loadable(lazy(() => import('./pages/dashboards/forum-list')));
const MYinfoEdit = Loadable(lazy(() => import('./pages/myinfo-edit')));
const AccountInfo = Loadable(lazy(() => import('./pages/account-info')));
const SignupModal = Loadable(lazy(() => import('./pages/signup-modal')));
const LoginModal = Loadable(lazy(() => import('./pages/login-modal')));
const Jungbaksa = Loadable(lazy(() => import('./pages/jungbaksa')));
const TextEditor = Loadable(lazy(() => import('./pages/text-editor')));
const Survery = Loadable(lazy(() => import('./pages/survey')));
const Wrtn = Loadable(lazy(() => import('./pages/wrtn')));
const Wrtn2 = Loadable(lazy(() => import('./pages/wrtn2')));
const WrtnChat = Loadable(lazy(() => import('./pages/wrtn-chat')));
const Statistics = Loadable(lazy(() => import('./pages/namecard/statistics')));
const DBprocess = Loadable(lazy(() => import('./pages/DBprocess')));
const Namecard = Loadable(lazy(() => import('./pages/namecard/namecard')));
const JiwongumMain = Loadable(lazy(() => import('./pages/jiwongum/main')));
const MainAi = Loadable(lazy(() => import('./pages/jiwongum-ai/main-ai')));
const MainAiGradient = Loadable(
  lazy(() => import('./pages/jiwongum-ai/main-ai-gradient'))
);
const JiwongumMain2 = Loadable(lazy(() => import('./pages/jiwongum/main2')));
const JiwongumMain3 = Loadable(lazy(() => import('./pages/jiwongum/main3')));
const JiwongumDetail = Loadable(
  lazy(() => import('./pages/jiwongum/jiwongum-detail'))
);
const JiwongumFind = Loadable(lazy(() => import('./pages/jiwongum/find')));
const JiwongumInquiry = Loadable(
  lazy(() => import('./pages/jiwongum/inquiry'))
);
const JiwongumCalculate1 = Loadable(
  lazy(() => import('./pages/jiwongum/calculate1'))
);
const JiwongumCalculate2 = Loadable(
  lazy(() => import('./pages/jiwongum/calculate2'))
);
const JiwongumCalculate3 = Loadable(
  lazy(() => import('./pages/jiwongum/calculate3'))
);
const JiwongumCalculate4 = Loadable(
  lazy(() => import('./pages/jiwongum/calculate4'))
);
const JiwongumCalculate5 = Loadable(
  lazy(() => import('./pages/jiwongum/calculate5'))
);
const JiwongumCalculate6 = Loadable(
  lazy(() => import('./pages/jiwongum/calculate6'))
);
const JiwongumCalculate7 = Loadable(
  lazy(() => import('./pages/jiwongum/calculate7'))
);
const JiwongumContents = Loadable(
  lazy(() => import('./pages/jiwongum/contents'))
);
const NamecardProfile = Loadable(
  lazy(() => import('./pages/namecard/profile'))
);

const BusinessPlan2 = Loadable(lazy(() => import('./pages/business-plan2')));

const ForumDetail = Loadable(
  lazy(() => import('./pages/dashboards/forum-detail'))
);
const Course = Loadable(lazy(() => import('./pages/dashboards/course')));
const CourseMain = Loadable(lazy(() => import('./pages/course-main')));

const ProjectManagement = Loadable(
  lazy(() => import('./pages/dashboards/project-management'))
);
const ProjectManagementV2 = Loadable(
  lazy(() => import('./pages/dashboards/project-management-v2'))
);
const JobManagement = Loadable(
  lazy(() => import('./pages/dashboards/job-management'))
);
const LearningManagement = Loadable(
  lazy(() => import('./pages/dashboards/learning-management'))
); // account

const AddUser = Loadable(lazy(() => import('./pages/user-list/add-new-user')));
const UserList = Loadable(
  lazy(() => import('./pages/user-list/user-list-view'))
);

const DataTableV2 = Loadable(
  lazy(() => import('./pages/data-table/data-table-v2'))
); // invoice

const DataTableTeamLeader = Loadable(
  lazy(() => import('./pages/data-table/data-table-team-leader'))
);

const VideoEditor = Loadable(lazy(() => import('./pages/video-editor')));
const CompanyList = Loadable(lazy(() => import('./pages/company-list')));
const MenuEditor = Loadable(lazy(() => import('./pages/menu-editor')));
const BannerEditor = Loadable(lazy(() => import('./pages/banner-editor')));

const ShoppingList = Loadable(
  lazy(() => import('./pages/shopping/shopping-list'))
);
const ShoppingDetail = Loadable(
  lazy(() => import('./pages/shopping/shopping-detail'))
);
const ShoppingReview = Loadable(
  lazy(() => import('./pages/shopping/shopping-review'))
);
const ShoppingPayment = Loadable(
  lazy(() => import('./pages/shopping/shopping-payment'))
);
const ShoppingPaymentHistory = Loadable(
  lazy(() => import('./pages/shopping/shopping-payment-history'))
);
const ShoppingOrder = Loadable(
  lazy(() => import('./pages/shopping/shopping-order'))
);
const APImanagement = Loadable(
  lazy(() => import('./pages/dashboards/APImanagement'))
);
const UserPaymentManagement = Loadable(
  lazy(() => import('./pages/dashboards/user-payment-manage'))
);
const PopupAd = Loadable(lazy(() => import('./pages/popup-ad')));

const Landing = Loadable(lazy(() => import('./pages/landing')));
const LandingMain = Loadable(
  lazy(() => import('./pages/landing/landing-main'))
);
const LandingDidi = Loadable(
  lazy(() => import('./pages/landing/landing-didi'))
);
const Landing2 = Loadable(lazy(() => import('./pages/landing/landing-2')));
const Landing3 = Loadable(lazy(() => import('./pages/landing/landing-3')));
const Landing4 = Loadable(lazy(() => import('./pages/landing/landing-4')));
const Landing5 = Loadable(lazy(() => import('./pages/landing/landing-5')));

const WorkSchedule = Loadable(lazy(() => import('./pages/work-schedule')));

const BookingList = Loadable(
  lazy(() => import('./pages/booking/booking-list'))
);

const CommunityMain = Loadable(
  lazy(() => import('./pages/community/community-main'))
);

const CommunityBookmark = Loadable(
  lazy(() => import('./pages/community/community-bookmark'))
);

const CommunityCategory = Loadable(
  lazy(() => import('./pages/community/community-category'))
);

const CommunityDetail = Loadable(
  lazy(() => import('./pages/community/community-detail'))
);

const Following = Loadable(lazy(() => import('./pages/community/following')));
const Followers = Loadable(lazy(() => import('./pages/community/followers')));

const ProfileOther = Loadable(
  lazy(() => import('./pages/community/profile-other'))
);

const CommunityCalendar = Loadable(
  lazy(() => import('./pages/community/calendar'))
);

const LikedClasses = Loadable(
  lazy(() => import('./pages/community/liked-classes'))
);

const CommunityEditor = Loadable(
  lazy(() => import('./pages/community/community-editor'))
);

const Classes = Loadable(lazy(() => import('./pages/community/classes')));
const MyInfo = Loadable(lazy(() => import('./pages/community/myinfo')));
const PaymentHistory = Loadable(
  lazy(() => import('./pages/community/payment-history'))
);

const TextEditor2 = Loadable(lazy(() => import('./pages/text-editor2')));

const ReportCreator = Loadable(lazy(() => import('./pages/report-creator')));

const Survey1 = Loadable(lazy(() => import('./pages/survey/survey1')));
const Survey2 = Loadable(lazy(() => import('./pages/survey/survey2')));
const Survey3 = Loadable(lazy(() => import('./pages/survey/survey3')));

const BlurPost = Loadable(lazy(() => import('./pages/blur-post')));

const InsuranceSurvey = Loadable(
  lazy(() => import('./pages/insurance-chat/insurance-survey'))
);

const InsuranceChat = Loadable(
  lazy(() => import('./pages/insurance-chat/insurance-chat'))
);

const InsuranceDashboard = Loadable(
  lazy(() => import('./pages/insurance-chat/insurance-dashboard'))
);

const InsuranceTable = Loadable(
  lazy(() => import('./pages/insurance-chat/insurance-table'))
);

const InsuranceQuotation = Loadable(
  lazy(() => import('./pages/insurance-chat/insurance-quotation'))
);

const InsuranceQna = Loadable(
  lazy(() => import('./pages/insurance-chat/insurance-qna'))
);

const InsuranceSelfIntroduction = Loadable(
  lazy(() => import('./pages/insurance-chat/insurance-self-introduction'))
);

const InsuranceTaxInfo = Loadable(
  lazy(() => import('./pages/insurance-chat/insurance-tax-info'))
);

const InsuranceTaxReassessment = Loadable(
  lazy(() => import('./pages/insurance-chat/insurance-tax-reassessment'))
);

const InsuranceMenuEditor = Loadable(
  lazy(() => import('./pages/insurance-chat/insurance-menu-editor'))
);

const InsuranceBannerEditor = Loadable(
  lazy(() => import('./pages/insurance-chat/insurance-banner-editor'))
);

const InsuranceUserManagement = Loadable(
  lazy(() => import('./pages/insurance-chat/insurance-user-management'))
);

const InsuranceProgress = Loadable(
  lazy(() => import('./pages/insurance-chat/insurance-progress'))
);

const InsuranceServerManagement = Loadable(
  lazy(() => import('./pages/insurance-chat/insurance-server-management'))
);

const Kmong = Loadable(lazy(() => import('./pages/kmong')));
const CallmetellmeMain2 = Loadable(
  lazy(() => import('./pages/callmetellme/main-2'))
);
const CallmetellmeCommunityMain = Loadable(
  lazy(() => import('./pages/callmetellme/comminity/callmetellmeCommunityMain'))
);
const CallmetellmeMypageMain = Loadable(
  lazy(() => import('./pages/callmetellme/mypage/callmetellmeMypageMain'))
);
const CallmetellmeJiwongumMain = Loadable(
  lazy(() => import('./pages/callmetellme/jiwongum/main'))
);
const CallmetellmeJiwongumCategory = Loadable(
  lazy(() => import('./pages/callmetellme/jiwongum/category'))
);
const CallmetellmeBusinessPlan = Loadable(
  lazy(() => import('./pages/callmetellme/business-plan'))
);

const Membership = Loadable(lazy(() => import('./pages/Membership')));
const Membership3 = Loadable(lazy(() => import('./pages/Membership3')));
const CallmetellmeMain1 = Loadable(
  lazy(() => import('./pages/callmetellme/main-1'))
);

const TableEditor = Loadable(lazy(() => import('./pages/excel/table-editor')));
const MembershipTable = Loadable(
  lazy(() => import('./pages/excel/membership-table'))
);

const InsuranceTableEditor = Loadable(
  lazy(() => import('./pages/insurance-chat/insurance-table-editor'))
);

const ServicePrompts = Loadable(
  lazy(() => import('./pages/crm/service-prompts'))
);
const MenuManagement = Loadable(
  lazy(() => import('./pages/crm/menu-management'))
);
const Upload = Loadable(lazy(() => import('./pages/course/upload/upload')));

const PartnersApply = Loadable(lazy(() => import('./pages/partners/apply')));

const PartnersRank = Loadable(lazy(() => import('./pages/partners/rank')));

const Error = Loadable(lazy(() => import('./pages/404')));

const routes = () => {
  return [
    ...authRoutes,
    {
      path: 'dashboard',
      element: (
        <>
          <ScrollToTop />
          <LayoutV1 />
        </>
      ),
      children: dashboardRoutes,
    },
    {
      path: 'naver',
      element: (
        <>
          {/* 새 페이지 열면 항상 스크롤이 맨 위로 이동 */}
          <ScrollToTop />
          <LayoutV2 />
        </>
      ),
      children: naverRoutes,
    },
    {
      path: '*',
      element: <Error />,
    },
  ];
};

const authRoutes = [
  {
    path: '/',
    element: <Navigate to="/naver/coursemain" />,
  },
];
const dashboardRoutes = [
  {
    path: '',
    element: <LearningManagement />,
  },
  {
    path: 'job-management',
    element: <JobManagement />,
  },
  {
    path: 'sales',
    element: <Sales />,
  },
  {
    path: 'sales-v2',
    element: <SalesV2 />,
  },
  {
    path: 'crm',
    element: <CRM />,
  },
  {
    path: 'saas',
    element: <SaaS />,
  },
  {
    path: 'sub-child-v1',
    element: <SalesV2 />,
  },
  {
    path: 'data-table-v2',
    element: <DataTableV2 />,
  },
  {
    path: 'data-table-team-leader',
    element: <DataTableTeamLeader />,
  },
  {
    path: 'add-user',
    element: <AddUser />,
  },
  {
    path: 'user-list',
    element: <UserList />,
  },
  {
    path: 'excel',
    element: <Excel />,
  },
  {
    path: 'excel2',
    element: <Excel2 />,
  },
  {
    path: 'progress',
    element: <Progress />,
  },
  {
    path: 'progress2',
    element: <Progress2 />,
  },
  {
    path: 'calendar',
    element: <Calendar />,
  },

  {
    path: 'forumdetail',
    element: <ForumDetail />,
  },

  {
    path: 'myinfoedit',
    element: <MYinfoEdit />,
  },
  {
    path: 'accountinfo',
    element: <AccountInfo />,
  },
  {
    path: 'signup',
    element: <SignupModal />,
  },
  {
    path: 'login',
    element: <LoginModal />,
  },
  {
    path: 'texteditor',
    element: <TextEditor />,
  },
  {
    path: 'survey',
    element: <Survery />,
  },

  {
    path: 'statistics',
    element: <Statistics />,
  },
  {
    path: 'namecardProfile',
    element: <NamecardProfile />,
  },
  {
    path: 'dbprocess',
    element: <DBprocess />,
  },
  {
    path: 'jiwongumdetail',
    element: <JiwongumDetail />,
  },
  {
    path: 'videoeditor',
    element: <VideoEditor />,
  },
  {
    path: 'bannereditor',
    element: <BannerEditor />,
  },
  {
    path: 'menueditor',
    element: <MenuEditor />,
  },
  {
    path: 'companylist',
    element: <CompanyList />,
  },
  {
    path: 'apimanagement',
    element: <APImanagement />,
  },
  {
    path: 'user-payment-management',
    element: <UserPaymentManagement />,
  },
  {
    path: 'popupad',
    element: <PopupAd />,
  },
  {
    path: 'blur-post',
    element: <BlurPost />,
  },
  {
    path: 'table-editor',
    element: <TableEditor />,
  },
];

const naverRoutes = [
  {
    path: '',
    element: <Naver />,
  },
  {
    path: 'naver',
    element: <Naver />,
  },
  {
    path: 'naverlist',
    element: <NaverList />,
  },
  {
    path: 'NoticeDetail',
    element: <NoticeDetail />,
  },
  {
    path: 'jungbaksa',
    element: <Jungbaksa />,
  },
  {
    path: 'wrtn',
    element: <Wrtn />,
  },
  {
    path: 'wrtn2',
    element: <Wrtn2 />,
  },
  {
    path: 'wrtn-chat',
    element: <WrtnChat />,
  },
  {
    path: 'course',
    element: <Course />,
  },
  {
    path: 'coursemain',
    element: <CourseMain />,
  },
  {
    path: 'main-ai',
    element: <MainAi />,
  },
  {
    path: 'main-ai-gradient',
    element: <MainAiGradient />,
  },
  {
    path: 'jiwongumMain',
    element: <JiwongumMain />,
  },
  {
    path: 'jiwongumMain2',
    element: <JiwongumMain2 />,
  },
  {
    path: 'jiwongumMain3',
    element: <JiwongumMain3 />,
  },
  {
    path: 'jiwongumfind',
    element: <JiwongumFind />,
  },
  {
    path: 'jiwonguminquiry',
    element: <JiwongumInquiry />,
  },
  {
    path: 'jiwongumcalculate1',
    element: <JiwongumCalculate1 />,
  },
  {
    path: 'jiwongumcalculate2',
    element: <JiwongumCalculate2 />,
  },
  {
    path: 'jiwongumcalculate3',
    element: <JiwongumCalculate3 />,
  },
  {
    path: 'jiwongumcalculate4',
    element: <JiwongumCalculate4 />,
  },
  {
    path: 'jiwongumcalculate5',
    element: <JiwongumCalculate5 />,
  },
  {
    path: 'jiwongumcalculate6',
    element: <JiwongumCalculate6 />,
  },
  {
    path: 'jiwongumcalculate7',
    element: <JiwongumCalculate7 />,
  },
  {
    path: 'jiwongumcontents',
    element: <JiwongumContents />,
  },
  {
    path: 'shoppinglist',
    element: <ShoppingList />,
  },
  {
    path: 'shoppingdetail',
    element: <ShoppingDetail />,
  },
  {
    path: 'shoppingreview',
    element: <ShoppingReview />,
  },
  {
    path: 'shoppingpayment',
    element: <ShoppingPayment />,
  },
  {
    path: 'shoppingpaymenthistory',
    element: <ShoppingPaymentHistory />,
  },
  {
    path: 'shoppingorder',
    element: <ShoppingOrder />,
  },
  {
    path: 'landing',
    element: <Landing />,
  },
  {
    path: 'landing-main',
    element: <LandingMain />,
  },
  {
    path: 'landing-didi',
    element: <LandingDidi />,
  },
  {
    path: 'landing2',
    element: <Landing2 />,
  },
  {
    path: 'landing3',
    element: <Landing3 />,
  },
  {
    path: 'landing4',
    element: <Landing4 />,
  },
  {
    path: 'landing5',
    element: <Landing5 />,
  },
  {
    path: 'bookinglist',
    element: <BookingList />,
  },
  {
    path: 'forumlist',
    element: <ForumList />,
  },
  {
    path: 'workschedule',
    element: <WorkSchedule />,
  },
  {
    path: 'community',
    element: <CommunityMain />,
  },
  {
    path: 'community/category',
    element: <CommunityCategory />,
  },
  {
    path: 'community/detail',
    element: <CommunityDetail />,
  },
  {
    path: 'community/bookmark',
    element: <CommunityBookmark />,
  },
  {
    path: 'community/profile/other',
    element: <ProfileOther />,
  },
  {
    path: 'community/calendar',
    element: <CommunityCalendar />,
  },
  {
    path: 'community/liked-classes',
    element: <LikedClasses />,
  },
  {
    path: 'community/myinfo',
    element: <MyInfo />,
  },
  {
    path: 'community/classes',
    element: <Classes />,
  },
  {
    path: 'community/payment-history',
    element: <PaymentHistory />,
  },
  {
    path: 'community/following',
    element: <Following />,
  },
  {
    path: 'community/followers',
    element: <Followers />,
  },
  {
    path: 'community/editor',
    element: <CommunityEditor />,
  },
  {
    path: 'texteditor2',
    element: <TextEditor2 />,
  },
  {
    path: 'report-creator',
    element: <ReportCreator />,
  },
  {
    path: 'report-creator-full',
    element: <ReportCreatorFull />,
  },
  {
    path: 'survey1',
    element: <Survey1 />,
  },
  {
    path: 'survey2',
    element: <Survey2 />,
  },
  {
    path: 'survey3',
    element: <Survey3 />,
  },
  {
    path: 'insurance/survey',
    element: <InsuranceSurvey />,
  },
  {
    path: 'insurance/chat',
    element: <InsuranceChat />,
  },
  {
    path: 'insurance/dashboard',
    element: <InsuranceDashboard />,
  },
  {
    path: 'insurance/table',
    element: <InsuranceTable />,
  },
  {
    path: 'insurance/quotation',
    element: <InsuranceQuotation />,
  },
  {
    path: 'insurance/qna',
    element: <InsuranceQna />,
  },
  {
    path: 'insurance/self-introduction',
    element: <InsuranceSelfIntroduction />,
  },
  {
    path: 'insurance/tax-info',
    element: <InsuranceTaxInfo />,
  },
  {
    path: 'insurance/tax-reassessment',
    element: <InsuranceTaxReassessment />,
  },
  {
    path: 'insurance/banner-editor',
    element: <InsuranceBannerEditor />,
  },
  {
    path: 'insurance/menu-editor',
    element: <InsuranceMenuEditor />,
  },
  {
    path: 'insurance/user-management',
    element: <InsuranceUserManagement />,
  },
  {
    path: 'insurance/progress',
    element: <InsuranceProgress />,
  },
  {
    path: 'insurance/server-management',
    element: <InsuranceServerManagement />,
  },
  {
    path: 'kmong',
    element: <Kmong />,
  },
  {
    path: 'callmetellme/main-2',
    element: <CallmetellmeMain2 />,
  },
  {
    path: 'callmetellme/community',
    element: <CallmetellmeCommunityMain />,
  },
  {
    path: 'callmetellme/jiwongum',
    element: <CallmetellmeJiwongumMain />,
  },
  {
    path: 'callmetellme/jiwongum/category',
    element: <CallmetellmeJiwongumCategory />,
  },
  {
    path: 'callmetellme/business-plan',
    element: <CallmetellmeBusinessPlan />,
  },
  {
    path: 'callmetellme/business-plan2',
    element: <BusinessPlan2 />,
  },
  {
    path: 'callmetellme/mypage',
    element: <CallmetellmeMypageMain />,
  },
  {
    path: 'callmetellme/mypage/ai-recommended-support-programs',
    element: <AIRecommendedSupportPrograms />,
  },
  {
    path: 'callmetellme/mypage/ai-recommended-policy-funds',
    element: <AIRecommendedPolicyFunds />,
  },
  {
    path: 'callmetellme/mypage/bookmarked-support-programs',
    element: <BookmarkedSupportPrograms />,
  },
  {
    path: 'callmetellme/mypage/bookmarked-posts',
    element: <BookmarkedPosts />,
  },
  {
    path: 'callmetellme/mypage/my-comments',
    element: <MyComments />,
  },
  {
    path: 'callmetellme/mypage/my-posts',
    element: <MyPosts />,
  },
  {
    path: 'callmetellme/mypage/replies-to-my-comments',
    element: <RepliesToMyComments />,
  },
  {
    path: 'callmetellme/mypage/comments-on-my-posts',
    element: <CommentsOnMyPosts />,
  },
  {
    path: 'callmetellme/mypage/subscribed-products',
    element: <SubscribedProducts />,
  },
  {
    path: 'callmetellme/jiwongum/post-detail',
    element: <PostDetail />,
  },
  {
    path: 'callmetellme/community/category-list',
    element: <CallmetellmeCategoryList />,
  },
  {
    path: 'callmetellme/community/community-detail',
    element: <CallmetellmeCommunityDetail />,
  },
  {
    path: 'membership',
    element: <Membership />,
  },
  {
    path: 'membership2',
    element: <Membership2 />,
  },
  {
    path: 'membership3',
    element: <Membership3 />,
  },
  {
    path: 'namecard',
    element: <Namecard />,
  },
  {
    path: 'callmetellme/main-1',
    element: <CallmetellmeMain1 />,
  },
  {
    path: 'insurance/table-editor',
    element: <InsuranceTableEditor />,
  },
  {
    path: 'table-editor/membership-table',
    element: <MembershipTable />,
  },
  {
    path: 'course-upload',
    element: <Upload />,
  },
  {
    path: 'partners/apply',
    element: <PartnersApply />,
  },
  {
    path: 'partners/rank',
    element: <PartnersRank />,
  },
  {
    path: 'crm/customer-list/user-info',
    element: <UserInfo />,
  },
  {
    path: 'crm/customer-list',
    element: <CustomerList />,
  },
  {
    path: 'crm/create-board',
    element: <CreateBoard />,
  },
  {
    path: 'crm/banner-settings',
    element: <BannerSettings />,
  },
  {
    path: 'crm/youtube-upload',
    element: <YoutubeUpload />,
  },
  {
    path: 'crm/reported-posts-and-comments',
    element: <ReportedPostsAndComments />,
  },
  {
    path: 'crm/comment-list',
    element: <CommentList />,
  },
  {
    path: 'crm/service-prompts',
    element: <ServicePrompts />,
  },
  {
    path: 'crm/menu-management',
    element: <MenuManagement />,
  },
];
export default routes;
